import LayoutSkeletons from './LayoutSkeletons';

export default LayoutSkeletons;
